import React, {createContext, useState, useContext} from 'react';
import ReactDOM from 'react-dom';
import GlobalNotification from "./GlobalNotification";

const NotificationContext = createContext();

export const NotificationProvider = ({children}) => {
  const [notification, setNotification] = useState(null);

  const showNotification = (message, duration = 3000) => {
    setNotification(message);
    if (duration) {
      setTimeout(() => setNotification(null), duration);
    }
  };

  return (
    <NotificationContext.Provider value={{showNotification}}>
      {children}
      {notification && ReactDOM.createPortal(
        <GlobalNotification
          message={notification}
          onClose={() => setNotification(null)}
        />,
        document.body
      )}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);